<div id = "confirmActionWrapper">
  @if (statusMessageType === 'Success') {
    <div>
      <div style = "margin-left: 35px;">
        <mat-icon style = "color: green;" id = "successFailIcon">check_circle_outline</mat-icon>
      </div>
      <div class = "center">
        <p>Success!</p>
      </div>
      @if (!editMoreAvailable) {
        <div class = "center">
          <p>Reloading soon:</p>
        </div>
      }
      @if (!editMoreAvailable) {
        <div class = "center" style = "height: 25px; margin-top: -15px; margin-bottom: 15px;">
          <h1 id = "point1">.</h1>
          <h1 id = "point2">.</h1>
          <h1 id = "point3">.</h1>
        </div>
      }
      @if (editMoreAvailable) {
        <div class = "center">
          <button mat-raised-button class = "btnHoover" style="margin-bottom: 10px; color: white;" (click) = "openAddLayerMenu(false)">Edit more</button>
        </div>
      }
      @if (editMoreAvailable) {
        <div class = "center">
          <button mat-raised-button class = "btnHoover" style="margin-bottom: 10px; color: white;" (click) = "closeAddLayer()">Close</button>
        </div>
      }
    </div>
  }


  @if (statusMessageType === 'Error') {
    <div>
      <div style = "margin-left: 35px;">
        <mat-icon style = "color: red;" id = "successFailIcon">error_outline</mat-icon>
      </div>
      <div class = "center">
        <p>Sorry, Something went wrong</p>
      </div>
      <!--
      <div class = "center">
        <h3>):</h3>
      </div>
      -->
      <div class = "center" style = "margin-top: 5px; margin-bottom: 5px;">
        <button mat-raised-button class = "btnHoover" style="margin-bottom: 0px; color: white;" (click) = "closeAddLayer()">Close</button>
      </div>
    </div>
  }

  @if (statusMessageType === 'Delete') {
    <div>
      <div class = "center" style = "font-weight: bold;">
        Layer Name:
      </div>
      <div class = "center">
        <p>{{layerToDelete}}</p>
      </div>
      <div class = "center">
        <p>Choose what to delete</p>
      </div>
      <div id = "deleteOptions">
        <div>
          <mat-checkbox [(ngModel)] = "file">File</mat-checkbox>
          <mat-icon style = "color: #D93636;">delete_outline</mat-icon>
        </div>
        <div>
          <mat-checkbox [(ngModel)] = "layer">Layer</mat-checkbox>
          <mat-icon style = "color: #D93636;">delete_outline</mat-icon>
        </div>
        <div>
          <mat-checkbox [(ngModel)] = "style">Used Style</mat-checkbox>
          <mat-icon style = "color: #D93636;">delete_outline</mat-icon>
        </div>
      </div>
      <div class = "centerButtons">
        <button mat-raised-button class = "btnHoover" style="margin-bottom: 0px; color: white;" (click) = "openAddLayerMenu(false)">Back</button>
        <button mat-raised-button class = "btnHoover" id = "deleteBtn" color="warn" style="margin-bottom: 0px; color: white;" (click) = "sendDeleteOptions()">Delete</button>
      </div>
    </div>
  }

</div>


